<div class="container">
  <mat-toolbar>
      <span>Reasignaci&oacute;n</span>
    </mat-toolbar>
  <form class="search-form" [formGroup]="filterForm">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Fecha inicio</mat-label>
          <input matInput [matDatepicker]="fechaInicio" [max]="maxDate" formControlName="fechaInicio">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="fechaInicio"></mat-datepicker-toggle>
          <mat-datepicker #fechaInicio></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Fecha fin</mat-label>
          <input matInput [matDatepicker]="fechaFin" [max]="maxDate" formControlName="fechaFin">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="fechaFin"></mat-datepicker-toggle>
          <mat-datepicker #fechaFin></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="full-width">
          <mat-label>Servidor p&uacute;blico</mat-label>
          <input type="text" matInput formControlName="participante" [matAutocomplete]="autoParticipante"
            (focus)="selectAllText($event)">
          <mat-autocomplete #autoParticipante="matAutocomplete" [displayWith]="displayParticipanteFn" (optionSelected)="onParticipanteSelected($event.option.value)">
            @for (participante of participantesFiltered | async; track participante) {
            <mat-option [value]="participante">                            
              <div class="my-multi-lines-item"><span class="my-multi-lines-text">{{participante.apellidos+" "+ participante.nombres}}<br><small><i>{{(participante.cargo||'')+" "+participante.ciruc}}</i></small></span></div>
              <span class="sgd-spacer"></span>
              <mat-icon class="ultimo-uso-{{participante.fechaUso|ultimoUso}}"
                style="float: inline-end; margin-right: 0;">man</mat-icon>
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field class="full-width">
          <mat-label>Texto a buscar</mat-label>
          <input type="text" matInput autoFocus placeholder="Asunto, n&uacute;mero, referencia, etc."
            formControlName="searchText" (keyup)="onKeyUp($event)" />
          @if((filterForm.controls.searchText.value?.trim()?.length||0)>0){
          <button type="reset" matSuffix mat-icon-button aria-label="Limpiar" (click)="onControlValueChanged()">
            <mat-icon>close_small</mat-icon>
          </button>
          }
          <button type="button" matSuffix mat-icon-button aria-label="Buscar" (click)="onControlValueChanged()">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  </form>

  <mat-toolbar class="toolbar-action">
    <button mat-button matTooltip="Reclamar" aria-label="Reclamar" (click)="onReasignar(0)"
      matTooltip="Reasigna documentos a otro servidor p&uacute;blico ">
      <mat-icon>supervisor_account</mat-icon> Reasignar
    </button>
    <!--<div class="sgd-spacer"></div>
    <button mat-button [disabled]="checkIfDisabled" (click)="onReasignar(1)"><mat-icon><mat-spinner color="accent" diameter="16" *ngIf="loading">
        </mat-spinner></mat-icon>Resignar todos los documentos ahora</button>-->
  </mat-toolbar>

  <mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear matSortDirection="desc">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="estados">
      <mat-header-cell *matHeaderCellDef>N&uacute;mero</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div>{{ element.anio + "-" + element.numero }}</div>
        <app-estados-documento [documento]="element"></app-estados-documento>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="de">
      <mat-header-cell *matHeaderCellDef>De</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        @for (item of element.de; track $index) {
        <p>{{item.nombres}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="para">
      <mat-header-cell *matHeaderCellDef>Para</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        @for (item of element.para; track $index) {
        <p>{{item.nombres}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="asunto">
      <mat-header-cell *matHeaderCellDef>Asunto</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.asunto }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef>Fecha</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        {{ formatDate(element.fechaAsignacion) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="numeroReferencia">
      <mat-header-cell *matHeaderCellDef>N&uacute;mero referencia</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.numeroReferencia }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="numeroDocumento">
      <mat-header-cell *matHeaderCellDef>N&uacute;mero documento</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <span>{{ element.numeroDocumento }}</span>
        <span>{{ element.anio + "-" + element.numero }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="usuarioAnterior">
      <mat-header-cell *matHeaderCellDef>Usuario anterior</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.usuarioAnterior }}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:false"></mat-header-row>
    <mat-row (click)="clickedRow(row)" *matRowDef="let row; columns: displayedColumns;"></mat-row>
    @if(!isLoadingResults){
    <div class="mat-row no-data-found" *matNoDataRow><app-no-data-found /></div>
    }

  </mat-table>
  @if(isLoadingResults){
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  * Esto puede tomar un par de minutos.
  }
  <mat-paginator #paginator [length]="resultsLength" pageSize="25" showFirstLastButtons
    aria-label="P&aacute;gina selecci&oacute;n documentos en elaboraci&oacute;n">
  </mat-paginator>
</div>